import { Action } from '../actions';
import { MY_NOTES, MY_OFFICES, SET_FIELDS, SET_TAG_SETTING, USER_CONTACT } from '../constants';
import { TypedCacheBucket } from '../models/state.models';

export interface SystemReducerState {
  fields: unknown | null;
  tag_setting: TypedCacheBucket;
  my_offices: unknown | null;
  notes: unknown | null;
  contact: TypedCacheBucket;
}

const initialState: SystemReducerState = {
  fields: null,
  my_offices: null,
  notes: null,
  contact: null,
  tag_setting: null,
};

export function SystemsReducer(state = initialState, action: Action): SystemReducerState {
  switch (action.type) {
    case SET_FIELDS: {
      return { ...state, fields: action.payload?.data ?? null };
    }
    case SET_TAG_SETTING: {
      return { ...state, tag_setting: action.payload?.data ?? null };
    }
    case MY_OFFICES: {
      return { ...state, my_offices: action.payload?.data ?? null };
    }
    case MY_NOTES: {
      return { ...state, notes: action.payload?.data ?? null };
    }
    case USER_CONTACT: {
      return { ...state, contact: action.payload?.data ?? null };
    }
    default: {
      return state;
    }
  }
}

export const getFields = (state: SystemReducerState) => state.fields;
export const getTags = (state: SystemReducerState) => state.tag_setting;
export const getMyOffices = (state: SystemReducerState) => state.my_offices;
export const getNotes = (state: SystemReducerState) => state.notes;
export const getContact = (state: SystemReducerState) => state.contact;
